module.exports = __webpack_public_path__ + "partner-1.jpg?d2362395a2903fe88c6189db1f6e352f";